// extracted by mini-css-extract-plugin
export default {"recaptcha":"GoogleRecapcha_recaptcha__LHHv4"};